'use client';

import { cn } from '@eliadmin/core/src/utils/style-utils';
import { useEffect, useState } from 'react';
import { MdArrowUpward } from 'react-icons/md';

export function BackToTop() {
  const [isOnTop, setIsOnTop] = useState(true);

  useEffect(() => {
    const updateIsOnTop = () => {
      setIsOnTop(window.scrollY < 1);
    };

    updateIsOnTop();
    window.addEventListener('scroll', updateIsOnTop, { passive: true });

    return () => {
      window.removeEventListener('scroll', updateIsOnTop);
    };
  }, []);

  return (
    <div
      onClick={() => {
        window.scrollTo({
          top: 0,
          behavior: 'smooth',
        });
      }}
      className={cn(
        'fixed bottom-16 right-4 z-[49] flex h-10 w-10 cursor-pointer items-center justify-center rounded-full bg-primary transition-all sm:bottom-8 sm:right-4',
        isOnTop && 'opacity-50',
      )}
    >
      <MdArrowUpward size={20} className="text-black" />
    </div>
  );
}
